import clsx from 'clsx';
import { ReactNode } from 'react';

export interface Props {
  text: string;
  children: ReactNode;
  position?:
    | 'top'
    | 'top-right'
    | 'right'
    | 'bottom-right'
    | 'bottom'
    | 'bottom-left'
    | 'left'
    | 'top-left';
  always?: boolean;
  rounded?: boolean;
  noShadow?: boolean;
  colorModifier?: 'error' | 'warning' | 'info' | 'success';
}

export function Tooltip(props: Props) {
  const {
    text,
    children,
    position = 'top',
    always = false,
    rounded = true,
    noShadow = true,
    colorModifier,
  } = props;

  return (
    <span
      className={clsx(
        `hint--${position}`,
        always && 'hint--always',
        rounded && 'hint--rounded',
        noShadow && 'hint--no-shadow',
        colorModifier && `hint--${colorModifier}`
      )}
      aria-label={text}
    >
      {children}
    </span>
  );
}

export default Tooltip;
